import { Button } from '@shared/components/ui/button';
import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
  error: Error;
  onRetry: () => void;
  className?: string;
  title?: string;
}

export const ErrorState = ({ error, onRetry, className = 'h-64', title }: ErrorStateProps) => {
  const { t } = useTranslation('accountingSyncModule');
  const displayTitle = title || t('errors.title');

  return (
    <div className={`flex items-center justify-center px-6 ${className}`}>
      <div className="text-center max-w-md">
        <h3 className="text-lg font-semibold text-foreground mb-2">{displayTitle}</h3>
        <p className="text-sm text-muted-foreground mb-4">{error.message}</p>
        <Button type="button" onClick={onRetry} variant="default">
          {t('buttons.retry')}
        </Button>
      </div>
    </div>
  );
};
